import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { ShieldCheck, ClipboardCheck, Users, Mic, MessageSquareHeart, CalendarHeart, ArrowLeft } from "lucide-react";

const links = [
  { to: "/admin/verifiche", label: "Verifications", icon: ClipboardCheck },
  { to: "/admin/utenti", label: "Users & Roles", icon: Users },
  { to: "/admin/contenuti", label: "Content", icon: Mic },
  { to: "/admin/testimonianze", label: "Testimonies", icon: MessageSquareHeart },
  { to: "/admin/incontri", label: "Meetings", icon: CalendarHeart },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b border-border bg-card">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <ShieldCheck className="w-5 h-5 text-primary" />
            <span className="font-heading text-xl uppercase tracking-[0.14em]">Back office</span>
          </div>
          <button onClick={() => navigate("/spazio")} className="text-sm text-muted-foreground flex items-center gap-1 hover:text-foreground transition-colors" data-testid="back-to-space-btn">
            <ArrowLeft className="w-4 h-4" /> Back to the space
          </button>
        </div>
      </header>
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-8 grid lg:grid-cols-[220px_1fr] gap-8">
        <nav className="flex lg:flex-col gap-1 overflow-x-auto">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} data-testid={`admin-nav-${l.label.split(" ")[0].toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm whitespace-nowrap transition-colors ${
                  isActive ? "bg-secondary text-primary" : "text-muted-foreground hover:bg-secondary/50"
                }`}>
              <l.icon className="w-4 h-4" /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="animate-fade-in-up"><Outlet /></div>
      </div>
    </div>
  );
}
